var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dea-price"},[(_vm.hasDiscountedPrice)?_c('span',{staticClass:"dea-heading--medium__s"},[_vm._v(_vm._s(_vm.salePrice)+" €")]):_vm._e(),_vm._v(" "),(_vm.regularPrice)?_c('span',{class:{
      'dea-price__regular--discounted dea-heading--light__xs': _vm.hasDiscountedPrice,
      'dea-heading--medium__s': !_vm.hasDiscountedPrice,
    }},[_vm._v(_vm._s(_vm.regularPrice)+" €")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }